import { render, staticRenderFns } from "./BaseTableResult.vue?vue&type=template&id=4e7c58e6&scoped=true&"
import script from "./BaseTableResult.vue?vue&type=script&lang=js&"
export * from "./BaseTableResult.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableResult.vue?vue&type=style&index=0&id=4e7c58e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7c58e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e7c58e6')) {
      api.createRecord('4e7c58e6', component.options)
    } else {
      api.reload('4e7c58e6', component.options)
    }
    module.hot.accept("./BaseTableResult.vue?vue&type=template&id=4e7c58e6&scoped=true&", function () {
      api.rerender('4e7c58e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Bases/Cards/BaseTableResult.vue"
export default component.exports